// extracted by mini-css-extract-plugin
module.exports = {"container":"MarriageWsForm_container_1fp3o","bottom-controls":"MarriageWsForm_bottom-controls_MaoKm"};